import { createContext } from 'react'

// 是否对话框
export const IsDialogContext = createContext(false)

// 对话框，由Dialog设置使用
export const DialogContext = createContext({} as any)

// form数据
export const FormDataContext = createContext({ props: {}, state: {} })
